import React from 'react';
import { Box, Button } from '@mui/material';
import { CreditCard } from '@mui/icons-material';
import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined';
import { useNavigate } from 'react-router-dom';

type TProps = {
  selectedAccount: 'PAYMENT' | 'CONTROL';
};

export const DashboardTypeSelector: React.FC<TProps> = ({ selectedAccount }) => {
  const navigate = useNavigate();

  return (
    <Box sx={{ mb: 3, display: 'flex', gap: 2 }}>
      <Button
        variant="outlined"
        startIcon={<CreditCard />}
        sx={{
          borderRadius: '999px',
          px: 3,
          height: 40,
          textTransform: 'none',
          cursor: 'default',
          fontWeight: 600,
          fontSize: '16px',
          color: 'primary.main',
          borderColor: 'primary.main',
          backgroundColor: '#F2F4F8',
          '&:hover': {
            backgroundColor: '#F2F4F8',
            borderColor: 'primary.main',
            color: 'primary.main',
          },
          ...(selectedAccount === 'CONTROL' && {
            visibility: 'hidden',
          }),
        }}
      >
        Conta movimento
      </Button>

      <Button
        variant="outlined"
        startIcon={<AccountBalanceWalletOutlinedIcon />}
        onClick={() => navigate('/banking/dashboard/receive')}
        sx={{
          borderRadius: '999px',
          px: 3,
          height: 40,
          cursor: 'pointer',
          textTransform: 'none',
          fontWeight: 500,
          fontSize: '16px',
          color: 'primary.main',
          borderColor: 'primary.main',
          backgroundColor: '#F2F4F8',
          '&:hover': {
            backgroundColor: '#F2F4F8',
            borderColor: 'primary.main',
            color: 'primary.main',
          },
          ...(selectedAccount === 'PAYMENT' && {
            visibility: 'hidden',
          }),
        }}
      >
        Conta Recebimento
      </Button>
    </Box>
  );
};
